import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ROUTES} from './shared/constants/routes';
import {AuthenticationService} from './shared/services/authentication.service';
import {CurrentUserService} from './shared/services/current-user.service';
import {ConfigService} from './shared/services/config.service';

@Component({
  selector: 'check-roles',
  template: 'Redirection vers la page d\'authentification en cours...',
})

export class CheckUserAuthenticationComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService,
              private currentUserService: CurrentUserService,
              private configService: ConfigService,
              private router: Router) {
  }

  ngOnInit(): void {
    console.log('[CheckAuth] ngOnInit() - auth enabled:', this.configService.isAuthEnabled());

    if (this.configService.isAuthEnabled()) {
      this.authenticationService.isDoneLoading$
        .subscribe({
          next: () => {
            console.log('[CheckAuth] isDoneLoading$ - token valid:', this.authenticationService.hasValidAccessToken());
            if (!this.authenticationService.hasValidAccessToken()) {
              console.log('[CheckAuth] Token invalide - refreshToken()...');
              this.authenticationService.refreshToken()
                .then(() => {
                  console.log('[CheckAuth] refreshToken() success - loading user...');
                  this.loadUserAndNavigate();
                })
                .catch(error => {
                  console.error('[CheckAuth] refreshToken() error:', error);
                  this.authenticationService.logIn();
                });

            } else {
              console.log('[CheckAuth] Token valide - loading user...');
              this.loadUserAndNavigate();
            }
          },
          error: (err) => {
            console.error('[CheckAuth] isDoneLoading$ error:', err);
          },
          complete: () => {
            console.log('[CheckAuth] isDoneLoading$ complete');
          }
        });

    } else {
      // ✅ Mode sans authentification - charger aussi l'utilisateur !
      console.log('[CheckAuth] Auth disabled - loading user in no-auth mode...');
      this.loadUserAndNavigate();
    }
  }

  /**
   * ✅ Charger l'utilisateur APRÈS validation du token, puis naviguer
   */
  private loadUserAndNavigate(): void {
    console.log('[CheckAuth] loadUserAndNavigate() - calling currentUserService.loadCurrentUser()');
    
    this.currentUserService.loadCurrentUser().subscribe({
      next: (user) => {
        console.log('[CheckAuth] loadCurrentUser() - user received:', user);
        if (user) {
          // ✅ Utilisateur chargé avec succès
          console.log('[CheckAuth] ✅ Utilisateur chargé:', user.identifier);
          this.router.navigateByUrl(`/${ROUTES.CORE_PATH}`);
        } else {
          // ❌ Utilisateur pas trouvé (peut arriver si token invalide)
          console.warn('[CheckAuth] ❌ Impossible de charger l\'utilisateur - null response');
          this.router.navigateByUrl(`/${ROUTES.CHECK_AUTH_PATH}`);
        }
      },
      error: (err) => {
        console.error('[CheckAuth] loadCurrentUser() error:', err);
        this.router.navigateByUrl(`/${ROUTES.CHECK_AUTH_PATH}`);
      },
      complete: () => {
        console.log('[CheckAuth] loadCurrentUser() complete');
      }
    });
  }
}